module.exports = __webpack_public_path__ + "aee9c636f50f91a61db91c31045929cb.svg";